module.exports = __webpack_public_path__ + "img/anesthesie.ed6bdb15.png";